














































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import Input1TextInputForSearch from '../basic-type-3-input/input-1-text-input-for-search.vue'


@Component({
  components: {
    Input1TextInputForSearch
  }
})
class Input4PropertyIdMapper extends Vue {
  @Prop({ default: '' }) propertyNameForId?: string
  @Prop({ default: '' }) propertyNameForValue?: string
  @Prop({ default: '' }) generalItemName?: string
  @Prop({ default: 3 }) maximumNumberOfItems?: number

  @Prop({ default: () => [] }) propertyNameRules?: any
  @Prop({ default: () => [] }) propertyValueRules?: any

  @Prop({ default: false }) outlined?: boolean
  @Prop({ default: true }) showListingTitle?: boolean
  @Prop({ default: '' }) prependIcon?: string

  @Prop({ default: false }) useAutocompleteName?: boolean
  @Prop({ default: () => () => [] }) autocompleteSearchFunction?: any

  @Prop({ default: () => [] }) initialItemList?: any[]
  @Prop({ default: () => [] }) initialItemObjectList?: any

  itemList: any[] = []
  itemObjectList: any[] = []

  hasErrorInput: boolean = false

  get isInitialValueChanged (): boolean {
    return JSON.stringify(this.initialItemList) !== JSON.stringify(this.itemList)
  }

  @Watch('initialItemList') updateInitialValue (value1: any, value2: any) {
    if (JSON.stringify(value1) === JSON.stringify(value2)) {
      return
    }
    Vue.set(this, 'itemList', this.createObjectCopy(this.initialItemList) || [])
  }

  mounted () {
    Vue.set(this, 'itemList', this.createObjectCopy(this.initialItemList) || [])
  }

  addItem () {
    if (this.useAutocompleteName) {
      this.itemList.push('')
    } else {
      this.itemList.push({ propertyName: '', propertyValue: '' })
    }
  }

  deleteItem (itemIndex: number) {
    this.itemList.splice(itemIndex, 1)
  }

  updateValue () {
    this.$emit('update-value', this.itemList)
  }

  selectSearchResult (itemId: any, index: number) {
    this.itemList[index] = itemId
  }

  async getInitialSelectedItemObject (index: number) {
    const initialItemObjectList = await this.initialItemObjectList

    if (!initialItemObjectList) {
      return []
    }

    if (!initialItemObjectList[index]) {
      return []
    }

    const itemObject = initialItemObjectList[index]

    return [{
      id: itemObject.itemId,
      name: itemObject.itemName,
      icon: itemObject.itemIconImageUrl
    }]
  }

  async getSearchResultList (searchText: string) {
    if (!searchText) { return [] }

    const searchResultList = await this.autocompleteSearchFunction(searchText)

    return searchResultList.map((item: any) => {
      return {
        id: item.itemId,
        name: item.itemName,
        icon: item.itemIconImageUrl
      }
    })
  }

  resetInputValue () {
    Vue.set(this, 'itemList', Object.assign([], this.initialItemList) || [])
  }

  receiveErrorFromInput (hasErrorInput: any) {
    this.hasErrorInput = hasErrorInput
  }

  createObjectCopy (object: any) {
    return JSON.parse(JSON.stringify(object))
  }

}

export default Input4PropertyIdMapper

